import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import ArrowDropDownRoundedIcon from '@material-ui/icons/ArrowDropDownRounded';

import { COLORS } from 'constants/index';
import useGlobalStyles from 'hooks/useGlobalStyles';
import useShows from 'hooks/useShows';
import typography from 'theme/typography';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 8px',
    boxShadow: `inset 0px -1px 0px ${COLORS.GRAY}`,
    cursor: 'pointer',
  },
  show: {
    ...typography.body1,
    lineHeight: '16px',
    letterSpacing: '0.125px',
    fontWeight: 900,
    marginLeft: '8px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

interface Props {
  isClickable?: boolean;
  onClick?: () => void;
}

const ShowPicker: React.FC<Props> = (props) => {
  const { isClickable, onClick } = props;
  const classes = useStyles();
  const globalClasses = useGlobalStyles();
  const { selectedShow } = useShows();

  const handleClick = () => isClickable && onClick && onClick();

  return (
    <div className={classes.root} onClick={handleClick}>
      <img
        className={globalClasses.thumbnail}
        src={selectedShow.image}
        alt={`${selectedShow.title} Thumbnail`}
      />
      <Typography className={classes.show} variant="body1">
        {selectedShow.title}
      </Typography>
      <ArrowDropDownRoundedIcon />
    </div>
  );
};

export default ShowPicker;
